package com.gsb.vyapar.bhagya.presentation.category.add.view

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.painter.BitmapPainter
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.datasource.network.KtorClient
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.interactor.util.resizeImage
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButton
import com.gsb.vyapar.bhagya.presentation.common.toolbar.Toolbar
import com.gsb.vyapar.bhagya.toComposeImageBitmap
import com.gsb.vyapar.bhagya.util.gvbLog
import io.github.vinceglb.filekit.compose.rememberFilePickerLauncher
import io.github.vinceglb.filekit.core.PickerType
import io.kamel.image.KamelImage
import io.kamel.image.asyncPainterResource
import io.ktor.util.encodeBase64
import korlibs.io.compression.compress
import korlibs.io.compression.deflate.GZIP
import korlibs.io.compression.uncompress
import kotlinx.coroutines.launch

@Composable
fun AddCategoryView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        val coroutineScope = rememberCoroutineScope()
        var imageString by remember { mutableStateOf("https://i.imghippo.com/files/XyS9675nno.png") }
        var image by remember { mutableStateOf<ImageBitmap?>(null) }
        var imageCompressed by remember { mutableStateOf<ImageBitmap?>(null) }
        var imageCompressedNew by remember { mutableStateOf<ImageBitmap?>(null) }
        val imagePickerLauncher = rememberFilePickerLauncher(PickerType.Image) { selectedImage ->
            coroutineScope.launch {
                val data = selectedImage?.readBytes()
                data?.let {
                    val uploadResponse = KtorClient.uploadGithubImageN(data).getOrNull()
                    uploadResponse?.content?.downloadUrl?.let {
                        image = KtorClient.downloadImage(it).getOrNull()?.toComposeImageBitmap()
                    }
                }
            }
        }
        Column(
            modifier = Modifier
                .verticalScroll(rememberScrollState())
                .fillMaxWidth()
        ) {
            Toolbar("AddCategoryView")
            Spacer(Modifier.height(16.dp))
            GVBButton(text = "Pick Image", onClick = {
                imagePickerLauncher.launch()
            })
            Spacer(Modifier.height(16.dp))
            image?.let { imageBitmap ->
                Column(
                    verticalArrangement = Arrangement.Center,
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Image(
                        painter = BitmapPainter(imageBitmap),
                        contentDescription = "search_image",
                        modifier = Modifier.width(500.dp).height(500.dp),
                    )
                }
            }
            imageCompressed?.let { imageBitmap ->
                Column(
                    verticalArrangement = Arrangement.Center,
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Image(
                        painter = BitmapPainter(imageBitmap),
                        contentDescription = "search_image",
                        modifier = Modifier.width(500.dp).height(500.dp),
                    )
                }
            }
            Spacer(Modifier.height(16.dp))
//            KamelImage(
//                { asyncPainterResource(imageString) },
//                contentDescription = "Profile"
//            )
            imageCompressedNew?.let { imageBitmap ->
                Column(
                    verticalArrangement = Arrangement.Center,
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Image(
                        painter = BitmapPainter(imageBitmap),
                        contentDescription = "search_image",
                        modifier = Modifier.width(500.dp).height(500.dp),
                    )
                }
            }
        }
    }
}